<template>
  <van-cell-group id="form_cell_group">
    <h3 class="cell_title">账户信息</h3>
    <van-field key="bankType" name="bank_acct_type" label="账户类型" :value="accountFormObj.bank_acct_type"
      :rules="[{ required: true, message: '请选择账户类型' }]">
      <template #input>
        <select-popup v-model="accountFormObj.bank_acct_type" :columns="banckTypeList" />
      </template>
    </van-field>
    <van-field key="bankName" name="bank_acct_name" v-model="accountFormObj.bank_acct_name" label="开户名称" placeholder="请输入"
      :rules="[{ required: true, message: '请输入开户账号名称' }]" />
    <van-field v-if="areaShow" key="bankLocation" name="bank_location" label="开户行所在地" :value="accountFormObj.bank_location"
      :rules="[{ required: true, message: '请选择开户行所在地' }]">
      <template #input>
        <select-popup v-model="accountFormObj.bank_location" :columns="province_list" />
      </template>
    </van-field>
    <van-field key="bankNo" name="bank_no" label="开户银行" :value="accountFormObj.bank_no"
      :rules="[{ required: true, message: '请选择开户银行' }]">
      <template #input>
        <search-picker v-model="accountFormObj.bank_no" :isServe="true" :columns="bankList" @searchChange="getColums" />
      </template>
    </van-field>
    <van-field key="bankAccount" name="bank_acct_no" v-model="accountFormObj.bank_acct_no" label="开户行帐号" placeholder="请输入"
      :rules="[{ required: true, message: '请输入与开户名称一致的银行账号' }]" />
    <van-field key="bankMobile" name="bank_mobile" v-model="accountFormObj.bank_mobile" label="银行预留手机号" placeholder="请输入"
      :rules="[
        { required: true, message: '请输入银行预留手机号' },
        {
          pattern: /^1[3456789]\d{9}$/,
          message: '银行预留手机号格式错误',
          trigger: 'onBlur',
        },
      ]" />
    <van-field v-if="accountFormObj.bank_acct_type === '1' || accountFormObj.bank_acct_type === ''" key="bankLicenceImg"
      name="pic_licence" label="开户许可证" :rules="[{ validator: uploadValidator, message: '请上传开户许可证' }]">
      <template #input>
        <CellUpload text="开户许可证" type="0006" v-model="accountFormObj.pic_licence" name="开户许可证" />
      </template>
    </van-field>
    <van-field v-else key="bankCardImg" name="pic_card" label="银行卡正面照"
      :rules="[{ validator: uploadValidator, message: '请上传银行卡正面照' }]">
      <template #input>
        <CellUpload text="银行卡正面照" type="0025" v-model="accountFormObj.pic_card" name="银行卡正面照" />
      </template>
    </van-field>
  </van-cell-group>
</template>

<script>
import { Toast } from "vant";
import SelectPopup from "./SelectPopup";
import CellUpload from "./CellUpload";
import SearchPicker from "./SearchPicker";
export default {
  components: {
    SelectPopup,
    CellUpload,
    SearchPicker,
  },
  props: ["reg_mer_type", "formObj"],
  data() {
    return {
      accountFormObj: {
        bank_acct_type: "",
        bank_acct_name: "",
        bank_location: "",
        bank_no: "",
        bank_acct_no: "",
        bank_mobile: "",
        pic_licence: {
          document_name: "开户许可证",
          document_type: "0006"
        },
        pic_card: {
          document_name: "银行卡正面照",
          document_type: "0025"
        },
      },
      banckTypeList: [],
      province_list: [],
      bankList: [],
      searchLoding: false,
      areaShow: true,
    };
  },
  created() {
    this.getAreaArr();
  },
  watch: {
    reg_mer_type: {
      handler(newV) {
        this.banckTypeList = [];
        this.accountFormObj.bank_acct_type = "";
        if (newV === "00" || newV === "03" || newV === "05") {
          this.banckTypeList.push({ text: "公司账户", value: "1" });
        } else if (newV === "02") {
          this.banckTypeList.push({ text: "个人账户", value: "0" });
        } else {
          this.banckTypeList.push(
            { text: "公司账户", value: "1" },
            { text: "个人账户", value: "0" }
          );
        }
      },
    },
    formObj: {
      handler(newV, oldV) {
        for (const key in this.accountFormObj) {
          if (this.accountFormObj[key] instanceof Object) {
            let pictureItem = newV.picture.filter(item => item.type === this.accountFormObj[key].document_type)
            if (pictureItem.length > 0) {
              this.accountFormObj[key] = {
                ...this.accountFormObj[key],
                file_path: pictureItem[0].tripartitePath,
                file_size: pictureItem[0].pictureSize,
                url: pictureItem[0].fastPath,
              }
            }
          } else if (key === 'bank_no') {
            this.accountFormObj.bank_no = JSON.stringify({ value: newV.commitData.complexUploadBasic.bank_no, text: newV.commitData.zwBankName })
          } else if (Object.hasOwnProperty.call(newV.commitData, key)) {
            this.accountFormObj[key] = newV.commitData[key]
          } else if (Object.hasOwnProperty.call(newV.commitData.complexUploadBasic, key)) {
            this.accountFormObj[key] = newV.commitData.complexUploadBasic[key]
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    uploadValidator(value, rule) {
      return value[0].file_path && value[0].file_path !== '' ? true : false
    },
    async getColums(key) {
      if (this.accountFormObj.bank_location === "") {
        Toast("请先选择开户行所在地");
      } else {
        this.searchLoding = true;
        let zwSelfContractType = this.$route.query.type;
        const res = await this.$apis.zzsignServe.getBankList({
          key,
          areaCode: this.accountFormObj.bank_location,
          zwSelfContractType,
        });
        if (res.resultCode === "200") {
          if (res.data.res_code === "0000") {
            this.bankList = res.data.branchBankList.map((item) => ({
              text: item.bankBranchName,
              value: item.code,
            }));
          } else {
            this.bankList = [];
          }
        }
        this.searchLoding = false;
      }
    },
    async getAreaArr() {
      this.areaShow = false
      const res = await this.$apis.zzsignServe.getArea({ code: "" });
      if (res.resultCode === "200") {
        this.province_list = res.data.map((item) => ({
          text: item.name,
          value: item.code,
        }));
        this.areaShow = true
      }
    },
  },
};
</script>

<style scoped lang="scss">
#form_cell_group {
  margin-top: 24px;

  .cell_title {
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    margin: 13px 0 3px;
  }
}
</style>